import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaFacebook, FaInstagram, FaTwitter, FaYoutube, FaPinterest,
  FaPhone, FaEnvelope, FaMapMarkerAlt, FaGem, FaCreditCard,
  FaShieldAlt, FaTruck, FaCertificate, FaArrowRight
} from 'react-icons/fa';
import { motion } from 'framer-motion';
import { useTheme } from '../../context/ThemeContext';

const FooterUser = () => {
  const { isDarkMode } = useTheme();

  const paymentMethods = [
    'https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg',
    'https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg',
    'https://upload.wikimedia.org/wikipedia/commons/b/b5/PayPal.svg',
    'https://upload.wikimedia.org/wikipedia/commons/f/fa/American_Express_logo_%282018%29.svg'
  ];

  const features = [
    { icon: <FaCertificate />, text: '100% Certified', desc: 'BIS Hallmarked Gold' },
    { icon: <FaTruck />, text: 'Free Shipping', desc: 'On orders above ₹10,000' },
    { icon: <FaShieldAlt />, text: 'Secure Payment', desc: 'SSL Encrypted' },
    { icon: <FaCreditCard />, text: 'Easy Returns', desc: '30 Day Returns' }
  ];

  return (
    <footer style={{
      background: isDarkMode ? 'var(--bg-secondary)' : 'var(--bg-tertiary)',
    }}>

      {/* Bottom Footer */}
      <div className="py-4">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <p className="mb-0 text-muted">
                © 2024 Bharat Gold. All rights reserved. |
                <Link to="/privacy" className="text-decoration-none ms-2" style={{ color: 'var(--primary-gold)' }}>
                  Privacy Policy
                </Link> |
                <Link to="/terms" className="text-decoration-none ms-2" style={{ color: 'var(--primary-gold)' }}>
                  Terms & Conditions
                </Link>
              </p>
            </div>
            <div className="col-lg-6 text-lg-end mt-3 mt-lg-0">
              <div className="d-flex gap-3 justify-content-lg-end align-items-center">
                <small className="text-muted">Secure Payments:</small>
                {paymentMethods.map((method, index) => (
                  <img
                    key={index}
                    src={method}
                    alt="Payment Method"
                    style={{
                      height: '30px',
                      filter: isDarkMode ? 'brightness(0) invert(1)' : 'none'
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterUser;